const cityField = {
  component: 'TextFieldHiddenSchema',
  maxLength: 40,
};

export default cityField;
